import { useEffect, useState } from 'react';
import { StreamKeyKappi } from '../types';
import { CAPTION_RTMP_API_URL } from '../config';

export function useGetStreamKeysAdmin(userId: string, accessToken: string, deps: any[] = []) {
  const [streamKeys, setStreamKeys] = useState<StreamKeyKappi[]>([]);
  useEffect(() => {
    const getStreamKeysForUser = async () => {
      const response = await fetch(`${CAPTION_RTMP_API_URL}/stream_keys/${userId}`, {
        headers: { authorization: `Bearer ${accessToken}` },
      });
      const errMsg: string = 'Failed to receive stream keys.';
      if (!response.ok || !response.headers.get('content-type')?.includes('application/json')) {
        console.error(errMsg);
        return;
      }
      const json = await response.json();
      if (!Array.isArray(json)) {
        console.error(errMsg);
        return;
      }

      const receivedStreamKeys: StreamKeyKappi[] = json.map(
        (item: any) =>
          ({
            user_id: userId,
            public_id: item.public_id,
            key: item.key,
            created_at: item.created_at,
            last_used_at: item.last_used_at,
          }) as StreamKeyKappi,
      );
      setStreamKeys(receivedStreamKeys);
    };
    if (streamKeys.length === 0) getStreamKeysForUser();
  }, [streamKeys.length, ...deps]);
  return streamKeys;
}
